import src from "IMAGE";
export default { src, width: 176, height: 62, blurWidth: 0, blurHeight: 0};
